import React from 'react';
import Layout from '../../components/Layout';
import WhyHostNew from './WhyHostNew';
import messages from '../../locale/jsonMessages';

let becomeHeaderCss = 'becomeHeaderCss';

export default async function action({ intl }) {
  const title = intl?.formatMessage(messages.whyListYourCarTabTitle);
  return {
    title,
    component: <Layout becomeHeader={true} becomeHeaderCss={becomeHeaderCss}><WhyHostNew title={title} /></Layout>,
  };
};
